import { styled } from '@mui/material/styles';

import { VAR_AREA_TOP } from '@mopla/constants';

export const ContentWrapper = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	minHeight: '100%',
	paddingInline: 16,
	paddingTop: 24,
	boxSizing: 'border-box',

	'& .logo': {
		marginBottom: 48,
	},

	'& .content': {
		flex: '1 1 auto',

		'& .title': {
			marginBottom: 24,
		},
	},
}));

export const BottomSliderScreenWrapper = styled('div')({
	display: 'grid',
	gridTemplate: `
		"topControls" max-content
		"legacyTitle" max-content
		"mainWithFooter" 1fr
		`,
	boxSizing: 'border-box',
	paddingTop: VAR_AREA_TOP,
	height: '100%',

	'& .topControls': {
		gridArea: 'topControls',
		paddingTop: 4,
		paddingInline: 16,
	},

	'& .legacyTitle': {
		gridArea: 'legacyTitle',
		marginTop: `calc(-1 * ${VAR_AREA_TOP})`,
	},

	'& .mainWithFooter': {
		gridArea: 'mainWithFooter',
	},
});
